import { TopicChipVariant } from './topic-chip.types';
import styles from './topic-chip.module.scss';
import clsx from 'clsx';

interface TopicChipProps {
  title: string;
  variant?: TopicChipVariant;
  className?: string;
  onClick?: () => void;
  isActive?: boolean;
}

export default function TopicChip({
  title,
  variant = 'primary',
  className,
  onClick,
  isActive,
}: TopicChipProps) {
  return (
    <>
      {variant === 'button' ? (
        <button
          type="button"
          onClick={onClick}
          className={clsx(
            styles.topicChip,
            styles[`topicChip-button`],
            {
              [styles['topicChip-button-active']]: isActive,
            },
            className
          )}
        >
          {title}
        </button>
      ) : (
        <div className={clsx(styles.topicChip, styles[`topicChip-${variant}`], className)}>
          {title}
        </div>
      )}
    </>
  );
}
